import { InjectionToken } from "@angular/core";
import { IInfrastructureService } from "./i-infrastructure.service";

export const infrastructureServiceInjectionToken: InjectionToken<IInfrastructureService> = new InjectionToken<IInfrastructureService>("digital-signage.user-dashboard.dashboard-web.InfrastructureService");
